import { GoalSettings } from "../../account/models/goals";
import { KeyValue } from "../../account/models/models";
import { ClientAppType } from "../../account/settings/models/settings-models";
import { AccountFeature } from "./IAccount";
import { Country, KeyValuePair } from "./models";

export interface RuleField {
    name: string;
    predicate: string;
    valueType: comparisonValueType;
    valuePlaceholder?: string;
    isDaysPredicate?: boolean;
    fieldType?: comparisonInputType;
    operatorType: ruleOperatorType;
    group: predicateGroupName;
    description?: string;
    feature?: AccountFeature;
    valuesGrouped?: boolean;
    clientApp?: ClientAppType;
    availableValues?: KeyValuePair[];
    isTooManyValues?: boolean;
}

export interface RulesConfig {
    rulesOperator: string;
    rulesGroups: RulesGroup[];
}

export interface RulesGroup {
    rulesOperator: string;
    rules: Rule[];

}

export interface Rule {
    comparisonPredicate: string;
    comparisonOperator: string;
    comparisonValue: string;
    daysPredicate?: number;
    comparisonArray?: string[];
    predicateType?: string;
}

export interface PredicateGroupSpec {
    name: predicateGroupName;
    label: string;
    showTitle: boolean;
}

export interface RulesOptions {
    config: RuleOptionsConfig;
    data: RuleOptionsData;
}

export interface RuleOptionsConfig {
    singleGroup?: boolean;
    fixedRules?: boolean;
    fixedPredicate?: boolean;
    rulesRequired?: boolean;
    hideGroupsOperatorToggle?: boolean;
    hideInGroupOperatorToggle?: boolean;
}

export type RuleOptionsData = {
    [key in comparisonValueType]?: RuleOptionsDataValue;
} | []

export type RuleOptionsDataValue =
    (KeyValue | string | GoalSettings | Country | { id: number; name: string; })[]
    | { [key: string]: { id: string; name: string; group: string }[] } // survey quesions
    | undefined;

export interface RuleOperatorConfig {
    name: string;
    label: string
}

export interface RulesConfigError {
    description: string;
    rulesErrors: RuleValidationError[];
}

export interface RuleValidationError {
    rule: Rule;
    invalidFieldType: RuleOperatorInvalidFieldType;
    invalidFieldValue: string;
}

export enum comparisonValueType {
    int,
    boolean,
    string,
    collection,
    campaigns_collection,
    sources_collection,
    source_types_collection,
    referrers_collection,
    areas_collection,
    country_iso_collection,
    region_iso_collection,
    industries_collection,
    target_lists,
    events_and_goals_collection,
    tags_collection,
    platforms_collection,
    devices_collection,
    malists_collection,
    domains_collection,
    units_collection,
    question_collection,
    sf_opportunity_stages_collection,
    drift_events_collection,
    company_sizes_collection,
    company_revenues_collection,
    sixsense_segments,
    audiences_collection,
    otws_collection,
    streams_collection,
    contact_target_lists,
    empty_collection,
    deals_stages,
}

export enum ruleOperatorType {
    ruleCollectionOperators,
    ruleIntGreaterThanOperators,
    ruleIntOperators,
    ruleStringOperators,
    ruleStringFromListOperators,
    ruleBooleanOperators,
    ruleSelectOneOperators,
    ruleIntOperatorsFull,
    ruleStringOperatorsFull,
    ruleCollectionOperatorsReduced,
    ruleCollectionOperatorContainsAny,
    ruleStringFromListOperatorsInclude,
    ruleCollectionOperatorsInclElementContains,
    ruleStringOperatorsForQuery,
    ruleStringOperatorsReduced,
    ruleStringOperatorsAceTargeting,
    ruleCollectionPositive
}

export enum comparisonInputType {
    textField,
    number,
    multiselect,
    chips,
    hidden,
    email,
    url,
    domain,
    dateTime,
    autocomplete,
    select,
    freeTextAutocomplete,
}

export enum predicateGroupName {
    visitor,
    activity,
    pages,
    sources,
    url,
    device,
    maGeneral,
    maFields,
    salesforce,
    crmAccount,
    crmOpportunity,
    crmLead,
    currentSession,
    company,
    visitorsActivity,
    deals,
}

export enum RuleOperatorInvalidFieldType {
    Predicate = 1,
    Operator = 2,
    Value = 3,
}
